import React from 'react';
import _ep_TEXT_SIMPLE_TITLE from "../components/_ep_TEXT_SIMPLE_TITLE";
import _ep_TEXT_TITLE_MORE from "../components/_ep_TEXT_TITLE_MORE";

const _epText = (props) => {
    const item = props?.item !== undefined ? props.item : props;

    switch (item?.ViewType) {
        case "SIMPLE_TITLE":
            return <_ep_TEXT_SIMPLE_TITLE texts={item?.Items}/>;
        case "TITLE_MORE":
            return <_ep_TEXT_TITLE_MORE texts={item?.Items}/>;
        default:
            return null;
    }
};

export default React.memo(_epText);
